/* eslint-disable import/no-extraneous-dependencies, @typescript-eslint/no-var-requires, import/no-import-module-exports */
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk/es';
import { trackingMiddleware } from '@is24at/react-tracking/redux';
import rootReducer from './reducers';

const createStoreAndConfigure = (initialState = {}) => {
  // ======================================================
  // Middleware Configuration
  // ======================================================
  const middleware = [thunk, trackingMiddleware];
  const composeEnhancers = composeWithDevTools({});

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================
  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middleware)),
  );

  if (__DEV__ && module.hot) {
    module.hot.accept('./reducers', () => {
      const nextRootReducer = require('./reducers').default; // eslint-disable-line global-require
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
};

export default createStoreAndConfigure;
